/*
 * Purpose : Service Class to handle tool sales form database, email and other backend services
 * Author : Soban
 * Copyright (c) - Globalfoundries 
 * 
 * Revision History
 * Version  | Date        | Author  | Description
 * -------------------------------------------------------------------------------------
 * 1.0      | 26-Oct-2021 | Soban   | Initial version
 * 
 */

import uniqid from 'uniqid';
import axios from 'axios';
import moment from 'moment';
import { readAndCompressImage } from 'browser-image-resizer';
import {approvalStages} from '../config/constants'
import arraybuffbase64 from 'base64-arraybuffer';
// remove me later
import { API, graphqlOperation, Storage } from 'aws-amplify';
//import _ from 'lodash'

export class ToolSalesFormService {

    async postForm(user, headerData, toolList, fileData, draft, headerDataOld, toolDataOld) {
        if(headerData.status === approvalStages.approved){
            if(headerData.total_price > headerDataOld.total_price){
                console.log("price changed")
            }
            else if(headerData.total_price < headerDataOld.total_price){
                console.log("price changed")
            }
            else if(headerData.buyer !== headerDataOld.buyer){
                console.log("buyer changed")
            }else{
                console.log("Nothing changed")
                return false
            }
        }

        let returnValue="";
        const uniqueId = uniqid.time()
        let deal_ref = "TS"+moment().format('YYMDhms');
        
        const createMutation = `mutation {
            createExcesstoolsalestransactions(
                input: {    
                        id:"${uniqueId}",
                        transactionid:"${uniqueId}",
                        deal_ref:"${deal_ref}",
                        transactiontype:"Tool Sales",
                        broker:"${headerData.broker}",
                        buyer:"${headerData.buyer}",
                        date:"${headerData.date}",
                        l3_fab_approver:"${headerData.l3_fab_approver}",
                        l3_fin_approver:"${headerData.l3_fin_approver}",
                        total_price:"${headerData.total_price}",
                        total_nbv:"${headerData.total_nbv}",
                        total_gain_loss:"${headerData.total_gain_loss}",
                        rejectedreason:"",
                        comment:"${headerData.comment?headerData.comment.replace(/[\n\r]+/g, " "):""}",
                        initiator:"${user}",
                        last_updated_by:"${user}",
                        status:"${draft?approvalStages.draft:approvalStages.l1Approval}"
                    }
                )
                {transactionid}
        }`
        let updateStatus= draft    
                        ? approvalStages.draft
                        : headerData.status === approvalStages.draft
                        ? approvalStages.l1Approval
                        : headerData.status === approvalStages.l1reject
                        ? approvalStages.l1Approval
                        : headerData.status === approvalStages.l2reject
                        ? approvalStages.l2Approval
                        : headerData.status === approvalStages.l3reject
                        ? approvalStages.l3Approval
                        : (headerData.status === approvalStages.l3FinReject || headerData.status === approvalStages.l3FabReject)
                        ? headerData.status
                        : headerData.status === approvalStages.l4reject
                        ? approvalStages.l4Approval
                        : headerData.status === approvalStages.l5reject
                        ? approvalStages.l5Approval
                        : headerData.status === approvalStages.approved
                        ? approvalStages.approved
                        : "Unknow Status"
                        
        console.log("updateStatus=>",updateStatus)

        if(headerData.status === approvalStages.approved || headerData.status.indexOf("Rejected") !== -1){
            let histDtls = toolDataOld//await this.getLinkedToolListHistory(headerData.transactionid)
            console.log('histDtls=>',histDtls)
            let histTools = histDtls.map(item => item.toolid)
            console.log('histTools=>',histTools)

            console.log('toolList=>',toolList)
            let presentTools = toolList.map(item => item.toolid)
            console.log('presentTools=>',presentTools)
            let newTools = presentTools.filter( item => !histTools.includes(item))
            console.log("newTools=>",newTools)
            console.log('toolList=>',toolList)
            if( toolList.length > histTools.length  || newTools.length > 0 ){
                updateStatus = approvalStages.l1Approval
                console.log("new length")
            }
        }

        const updateMutation = `mutation {
            updateExcesstoolsalestransactions(
                input: {
                    id: "${headerData.id}",
                    broker: "${headerData.broker}",
                    buyer: "${headerData.buyer}",
                    comment:"${headerData.comment?headerData.comment.replace(/[\n\r]+/g, " "):""}",
                    date: "${headerData.date}",
                    l3_fab_approver:"${headerData.l3_fab_approver}",
                    l3_fin_approver:"${headerData.l3_fin_approver}",
                    last_updated_by:"${user}",
                    status:"${updateStatus}",
                    rejectedreason:"",
                    total_gain_loss:"${headerData.total_gain_loss}",
                    total_nbv:"${headerData.total_nbv}",
                    total_price:"${headerData.total_price}"
                })
                {
                    transactionid
                }
            }`
         console.log("createMutation==>",createMutation)
         console.log("updateMutation==>",updateMutation)
        await API.graphql(graphqlOperation(headerData.transactionid?updateMutation:createMutation ))
        .then(async result =>
            {
                console.log("result tool sales transaction create ==>",result)
                //return result.data.createExcesstoolsalestransactions?.transactionid
                const deal_txn_id = headerData.transactionid?headerData.transactionid:uniqueId
                console.log("deal_txn_id=>",deal_txn_id)
                const deal_ref_num = headerData.deal_ref?headerData.deal_ref:deal_ref
                console.log("deal_ref_num=>",deal_ref_num)
                console.log("toolList=>",toolList)
                headerData.transactionid && await this.deleteToolData(toolList,headerData.transactionid)
                await this.postToolData(deal_txn_id, deal_ref_num, toolList);
                //headerData.transactionid && await this.deletefileData(fileData,headerData.transactionid)
                // if(fileData.file){                    
                //     await this.postfileData(deal_txn_id, fileData);
                // }
                //console.log('draft=>',draft,!draft)
                console.log("headerData.status=>",headerData.status)
                let action = (headerData.status === approvalStages.draft
                                || !headerData.status
                                || headerData.status === approvalStages.l1reject)
                                ? approvalStages.draft
                                : headerData.status === approvalStages.l2reject
                                ? approvalStages.l1Approval
                                : headerData.status
                action = updateStatus === approvalStages.l1Approval ? approvalStages.draft : action
                console.log("action=>",action)

                !draft && await this.sendEmail(deal_ref_num,headerData,user,action,"",user,null,headerDataOld)
                //sendEmail(deal_ref, txnData, initiator, action, reason, reviewer, fileName, previousPrice, previousNbv, previousGainLoss, previousBuyer, previousBroker)
                
                returnValue = deal_ref_num
            }
        ).catch(async error => {
            await this.logError(error,"Error while processing sales transaction create")
            throw Error(`Error in sales transaction create`)
        });            
        return returnValue
    }
    async postToolData(transactionid, deal_ref, toolList){        
        if(toolList.length <= 0){
            return false
        }
        for (let toolItem of toolList) {
            const createMutation = `mutation {
                createExcesstoolsalestooldetails(input: {
                    id: "${toolItem.id}",
                    transactionid: "${transactionid}", 
                    toolid: "${toolItem.toolid}",
                    vendor: "${toolItem.vendor}",
                    asset_mgt_status: "${toolItem.asset_mgt_status?toolItem.asset_mgt_status:""}", 
                    fab: "${toolItem.fab}",
                    location: "${toolItem.location}", 
                    model: "${toolItem.model}", 
                    no_internal_reuse: "${toolItem.no_internal_reuse}", 
                    nbv: "${toolItem.nbv}",                     
                    price: "${toolItem.price}", 
                    org_eqp_price: "${toolItem.org_eqp_price}",
                    price_percent: "${toolItem.price_percent}",
                    capitalized_date: "${toolItem.capitalized_date}",
                    fin_analysis: "${toolItem.fin_analysis?toolItem.fin_analysis.replaceAll('"','\''):""}",
                    remarks: "${toolItem.remarks?toolItem.remarks.replaceAll('"','\''):""}",
                    sales_type: "${toolItem.sales_type}", 
                    serialnum: "${toolItem.serialnum}",
                    declared_type:"${toolItem.declared_type}"
                    deal_ref: "${deal_ref}"
                }) 
                {
                    transactionid
                }
            }`
            console.log("createMutation==>",createMutation)
            await API.graphql(graphqlOperation(createMutation))
            .then(async result =>
                {
                    console.log("result tool sales tool details create ==>",result.data.createExcesstoolsalestooldetails?.transactionid)
                    //return result.data.createExcesstoolsalestooldetails?.transactionid
                    //await this.postfileData(uniqueId, fileData);
                }
            ).catch(async error => {
                await this.logError(error,"Error while processing tool sales tool details submit.")
                throw Error(`Error`)
            });
        }
    }
    async postfileData(transactionid,fileData){
        let fileNameDet = fileData.name.split(".")
        let extension = fileNameDet[1];
        let fileName = fileData.name?.indexOf("-$") !==-1 ? fileData.name : fileNameDet[0].replace("%", " percent") + "-$" + transactionid + "." + extension
        console.log("fileName=>", fileName)
        
        const config = {
            quality: 0.8,
            maxWidth: 700,
            maxHeight: 700,
            mimeType: 'image/jpeg'
        };
        const file = fileData.file?.type?.indexOf("image/")!==-1 ? await readAndCompressImage(fileData.file, config) : fileData.file;

        await Storage.put(fileName, file, {
            contentType: fileData.mimetype
        })
        .then(async res => {
            console.log("res from storage =>", res)
            try {
                let id = Math.random().toString(36).slice(2)                
                const insertQuery = `mutation {
                    createExcesstoolsalesfilesdata(input: {
                        id: "${id}",
                        transactionid: "${transactionid}",
                        description:"${fileData.description?fileData.description:""}", 
                        mimetype:"${fileData.mimetype}",
                        name:"${res.key}"
                    })
                    {
                        name
                    }
                  }`
                await API.graphql(graphqlOperation(insertQuery))
                .then(result => {
                    console.log(`inserted createExcesstoolsalesfilesdata`)
                }).catch(error => {
                    console.log("error==>", error)
                    throw Error(`Error while inserting createExcesstoolsalesfilesdata`)
                });
            } catch (error) {
                throw new Error("Error inserting file data..")
            }
        })
        return fileName;
    }
    // delete tool sales header details
    async deleteHeaderData(transactionid){       
            let resultFLag ="";
            try {                
                //deleting header details
                const deleteHeaderData = `mutation  {
                    deleteExcesstoolsalestransactions(input: {id: "${transactionid}" }) {
                    transactionid
                    }
                }`                
                await API.graphql(graphqlOperation(deleteHeaderData))
                .then( result => console.log("header data deleted ==>",result.data.deleteExcesstoolsalestransactions?.transactionid) )
                .catch(error => { throw Error(error) } );
                
                // deleting tool details
                const toolQuery = `query {
                    listExcesstoolsalestooldetailss(filter: {transactionid: {eq: "${transactionid}" }}, limit: ${process.env.REACT_APP_TOOLSALES_TRANSACTION_TABLE_LIMIT} ) {
                      items {
                        id
                        transactionid
                      }
                    }
                  }`                
                await API.graphql(graphqlOperation(toolQuery))
                .then( async result => {                    
                    const toolIdList = result.data.listExcesstoolsalestooldetailss.items;
                    console.log("result toolIdList ==>", toolIdList)
                    toolIdList.length>0 && await this.deleteToolData(toolIdList)
                })
                .catch(error => { throw Error(error) } );

                // deleting file details
                let fileIdList = await this.getOldTxnFileData(transactionid)
                console.log('fileIdList.length=>',fileIdList)
                fileIdList && await this.deletefileData(fileIdList)

                resultFLag = "success";


            } catch (error) {                
                await this.logError(error,"Error while deleting the transaction.")
                throw Error(`Error`,error)
            }
            return resultFLag;             
    }
    // delete tool sales tool details
    async deleteToolData(toolList,oldTxnId){        
        console.log("toolList ==> ", toolList.length);        
        //console.log("toolList ==> ", toolList);        
        let existingTools = []
        if( toolList.length <= 0 ){            
            if(oldTxnId){
                existingTools = await this.getLinkedToolList(oldTxnId)
            }
            if(existingTools.length <=0){
                console.log("There is nothing to delete")
                return false;
            }
        }else{
            existingTools = await this.getLinkedToolList(toolList[0].transactionid)
        }
        console.log('existingTools=>',existingTools)
        if(existingTools.length <=0){
                console.log("There is nothing to delete")
            return false;
        }
        for (let toolItem of existingTools) {            
            const deleteToolDataQuery = `mutation {
                deleteExcesstoolsalestooldetails(
                    input: {
                        id: "${toolItem.id}",
                        transactionid: "${toolItem.transactionid?toolItem.transactionid:oldTxnId}"
                    }
                )
                {
                    transactionid
                }
            }`
            
            await API.graphql(graphqlOperation(deleteToolDataQuery))
            .then(async result =>
                {
                    console.log("result tool sales tool details delete ==>",result.data.deleteExcesstoolsalestooldetails?.transactionid)
                }
            ).catch(async error => {
                await this.logError(error,"Error while processing tool sales tool details submit")
                throw Error(`Error`)
            });
        }
    }

    // delete file data
    async deletefileData(fileData,oldTxnId){
        // deleting file details
        if(oldTxnId){
            fileData = await this.getOldTxnFileData(oldTxnId)
        }

        console.log("FILE DATA =>",fileData)
        let fileName = fileData.name
        console.log("FILE NAME =>", fileName)
        if(!fileName){
            return false
        }
        await Storage.remove(fileName)
        .then(async res => {
            console.log("res from storage =>", res)
            try {
                const deleteFileDataQuery = `mutation {
                    deleteExcesstoolsalesfilesdata(
                        input: {
                            id: "${fileData.id}", 
                            transactionid: "${fileData.transactionid}"
                        }
                    )
                    {
                        transactionid
                    }
                }`
                await API.graphql(graphqlOperation(deleteFileDataQuery))
                .then(result => {
                    console.log(`file deleted`)
                }).catch(error => {
                    console.log("error==>", error)
                    throw Error(`Error while deleting file`)
                });
            } catch (error) {
                throw new Error("Error deleting file data..")
            }
        })
    }

    // get dropdown list for tool sales form
    async getDropdownValues(){
        
        const brokerList = []
        const dropdownQuery = `query {
            listExcessbrokerconfigs(filter: {enable: {eq: "Yes"}}) {
                items {
                broker
                }
            }
            listExcesstransactionss(filter: {linked_to_deal: {ne: "Yes"}, and: {txnfab: {attributeExists: true}, and: {approved: {eq: "APPROVED"}}}}, limit: ${process.env.REACT_APP_TRANSACTION_TABLE_LIMIT}){
                items {
                    id
                    transactionid
                    toolid
                    txnfab
                    location
                    txn_assets_mgt_status
                    txn_uems_remarks
                    txnuemseqptid
                }
            }
        }`
        let dropdownApiData;
        try {
            dropdownApiData =await API.graphql(graphqlOperation(dropdownQuery))    
        } catch (error) {
            console.log("Error in initial data load : ",error)
            throw Error("Error in getting initial data. Please try again after sometime")
        }
        

        //setting brokers dropdown
        const brokerResults = dropdownApiData.data.listExcessbrokerconfigs.items;
        brokerResults.map( brokerObj => brokerList.push(brokerObj.broker) )
        console.log("brokerList=>",brokerList)
        brokerList.sort((a, b) =>
            a > b ? 1 : b > a ? -1 : 0
        );

        //setting tools dropdown
        const toolListResults = dropdownApiData.data.listExcesstransactionss.items;    
        console.log('toolListResults==>',toolListResults)
        toolListResults.sort((a, b) =>
            a.toolid.toLowerCase() > b.toolid.toLowerCase() ? 1 : b.toolid.toLowerCase() > a.toolid.toLowerCase() ? -1 : 0
        );

        return [brokerList,toolListResults];
    }

    // get dropdown values for tool search
    async getDropdownValuesForToolSearch(){
        
        const dropdownQuery =
        ` query {
            listExcesstransactionss(filter: {linked_to_deal: {ne: "Yes"}, and: {txnfab: {attributeExists: true}, and: {approved: {eq: "APPROVED"}}}}, limit: ${process.env.REACT_APP_TRANSACTION_TABLE_LIMIT}){
              items {
                transactionid
                toolid
              }
            }
            listExcesstoolsalestooldetailss(filter: {declared_type: {eq: "No"}}, limit: ${process.env.REACT_APP_TOOLSALES_TOOLDETAILS_TABLE_LIMIT}){
              items {
                transactionid
                toolid
              }
            }
          }
          `
        let dropdownApiData;
        try {
            dropdownApiData =await API.graphql(graphqlOperation(dropdownQuery))    
        } catch (error) {
            console.log("Error in dropdown data load : ",error)
            throw Error("Error in getting dropdown data. Please try again after sometime")
        }

        //setting tools dropdown
        const toolListResults = [...dropdownApiData.data.listExcesstransactionss.items,...dropdownApiData.data.listExcesstoolsalestooldetailss.items]
        toolListResults.sort((a, b) =>
            a.toolid.toLowerCase() > b.toolid.toLowerCase() ? 1 : b.toolid.toLowerCase() > a.toolid.toLowerCase() ? -1 : 0
        );
        
        return toolListResults;
    }

    async getTransactionDetailForEdit(txnId){
        try {
            //getting transaction header data
            const toolTransactionQuery = `query {
                listExcesstoolsalestransactionss(filter: {transactionid: {eq: "${txnId}"}}, limit: ${process.env.REACT_APP_TOOLSALES_TRANSACTION_TABLE_LIMIT} ) {
                    items {
                        broker
                        buyer
                        comment
                        date
                        id
                        initiator
                        l3_fab_approver
                        l3_fin_approver
                        nondeclared
                        rejectedreason
                        status
                        total_gain_loss
                        total_nbv
                        total_price
                        transactionid
                        transactiontype
                        deal_ref
                        last_updated_by
                    }
                }
                listExcesstoolsalesfilesdatas(filter: {transactionid: {eq: "${txnId}"}}, limit: ${process.env.REACT_APP_TOOLSALES_FILE_DATA_TABLE_LIMIT}) {
                    items {
                        description
                        id
                        mimetype
                        name
                        transactionid
                    }
                }
            }`
            const txnApiData =await API.graphql(graphqlOperation(toolTransactionQuery))
            console.log('txnApiData header ==>',txnApiData)
            return txnApiData   
        }catch(error){
            //console.log("error==>", error)
            throw Error(`Error while fetching txn data for edit. error : `,error)
        }        
    }

    async getLinkedToolList(txnId){
        try {
            const linkeToolListQry = `query {
                listExcesstoolsalestooldetailss(filter: {transactionid: {eq: "${txnId}"}}, limit: ${process.env.REACT_APP_TOOLSALES_TOOLDETAILS_TABLE_LIMIT}) {
                  items {
                    id
                    transactionid
                    vendor
                    toolid
                    serialnum
                    asset_mgt_status
                    fab
                    location
                    model
                    no_internal_reuse
                    nbv
                    price
                    org_eqp_price
                    price_percent
                    capitalized_date
                    fin_analysis
                    remarks
                    sales_type
                    declared_type
                  }
                }
              }`
              const linkedToolApiData =await API.graphql(graphqlOperation(linkeToolListQry))    
              //console.log("getLinkedToolList=>",linkedToolApiData.data.listExcesstoolsalestooldetailss.items)
              return linkedToolApiData.data.listExcesstoolsalestooldetailss.items;
        } catch (error) {
            console.log(`Error while fetching linked tool list txn data for edit. error : `,error)
            throw Error(`Error while fetching linked tool list txn data for edit. error : `,error)
        }
    }

    async getLinkedToolListHistory(txnId){
        try {
            const linkeToolListQry = `query {
                listExcesstoolsalestooldetailshistorys(filter: {transactionid: {eq: "${txnId}"}}, limit: ${process.env.REACT_APP_TOOLSALES_TOOLDETAILS_TABLE_LIMIT}) {
                  items {
                    toolid
                  }
                }
              }`
              const linkedToolApiData =await API.graphql(graphqlOperation(linkeToolListQry))    
              return linkedToolApiData.data.listExcesstoolsalestooldetailshistorys.items;
        } catch (error) {
            console.log(`Error while fetching linked tool list txn data for edit. error : `,error)
            throw Error(`Error while fetching linked tool list txn data for edit. error : `,error)
        }
    }

    async getTransactionDetails(){
        const txnQuery = `query {
            listExcesstoolsalestransactionss(limit:${process.env.REACT_APP_TRANSACTION_TABLE_LIMIT}) {
              items {
                broker
                buyer
                comment
                date
                id
                initiator
                l3_fab_approver
                l3_fin_approver
                nondeclared
                rejectedreason
                status
                total_gain_loss
                total_nbv
                total_price
                transactionid
                deal_ref
                updatedAt
              }
            }
          }`
          let apiData;
          try {
             apiData = await API.graphql(graphqlOperation(txnQuery));    
          } catch (error) {
            console.log("Error in getting Tool sales transaction data",error)
            throw Error("Error in getting Tool sales transaction data")
          }
          
          //const apiData =await API.graphql(graphqlOperation(query))
          console.log("api data=>",apiData.data.listExcesstoolsalestransactionss.items.length)
          return apiData.data.listExcesstoolsalestransactionss.items
          
    }

    async getToolGeneralData(txnId){
        try {
            const generalTableQuery =   `query {
                listExcessgenerals(limit: ${process.env.REACT_APP_GENERAL_TABLE_LIMIT}, filter: {transactionid: {eq: "${txnId}" }}) {
                  items {
                    model
                    serialno
                    vendorsupplier
                  }
                }
              }`
            const apiData =await API.graphql(graphqlOperation(generalTableQuery))
            const apiResult = apiData.data.listExcessgenerals.items;
            console.log('apiResult==>',apiResult)
            return apiResult
        } catch (error) {
            console.log(`Error while fetching tool general data. error : `,error)
            throw Error(`Error while fetching tool general data. error : `,error)
        }
    }
    async getUserRole(user){
        const q = `query 
            {
                listExcessuserroless(limit:${process.env.REACT_APP_USERROLES_TABLE_LIMIT}, filter: {id: {eq: "${user}" }}) {
                    items {
                    role
                    }
                }
            }`;
        const apiData =await API.graphql(graphqlOperation(q))
        const results = apiData.data.listExcessuserroless.items;            
        console.log("data fetched")
        return results
    }

    async getToolStatusDetails(toolid){
        const query = `query ToolStatusDetailsQuery {
            listExcesstoolsalestooldetailss(filter: {toolid: {eq: "${toolid}" }}, limit: ${process.env.REACT_APP_TOOLSALES_TOOLDETAILS_TABLE_LIMIT}) {
              items {
                transactionid
                toolid
                fab
                location
                model
                asset_mgt_status
                remarks
                serialnum
                vendor
                deal_ref
                price
                nbv                
                org_eqp_price
                price_percent
                capitalized_date
                fin_analysis
                no_internal_reuse
                sales_type
              }
            }
          }`
        let apiData;
        try {
            apiData = await API.graphql(graphqlOperation(query))
        } catch (error) {
            console.log(`Error while fetching tool general data. error : `,error)
            throw Error(`Error while fetching tool general data. error : `,error)
        }
        const results = apiData.data.listExcesstoolsalestooldetailss.items;
        return results
    }

    async getOldTxnFileData (oldTxnId){
        let fileData;
        const fileQuery = `query {
            listExcesstoolsalesfilesdatas(filter: {transactionid: {eq: "${oldTxnId}" }}, limit: ${process.env.REACT_APP_TOOLSALES_FILE_DATA_TABLE_LIMIT} ) {
                items {
                id
                transactionid
                name
                }
            }
            }`                
        await API.graphql(graphqlOperation(fileQuery))
        .then( async result => {                    
            const fileIdList = result.data.listExcesstoolsalesfilesdatas.items;
            console.log("result fileIdList ==>", fileIdList)
            fileData = fileIdList.length>0 && fileIdList[0]
        })
        .catch(error => { throw Error(error) } );
        return fileData
    }

    // update tool data on L1 and L2 approval
    // update excesstoolsalestransactions table : status, total_price, total_nbv, total_gain_loss, rejectedreason(if any) based on deal_ref
    // update excesstoolsalestooldetails table : nbv based on deal_ref
    // send email to L2 approver
    async updateDeal(headerData, toolList, user, callFrom, file_data){
        let returnTransactionid=null;
        let fileName = ""
        console.log("headerData.status=>",headerData.status)
        
        returnTransactionid = await this.updateTransaction(headerData, user, callFrom)       
        console.log("returnTransactionid 1 ->",returnTransactionid) 


        if(toolList.length <= 0 && (callFrom!=="reject" && callFrom!=="cancel")){
            return false
        }
        (callFrom!=="reject" && callFrom!=="cancel") && await this.updateToolData(toolList).then(res => returnTransactionid = res)
        console.log("returnTransactionid 2 ->",returnTransactionid)

        console.log("file_data.length=>",file_data)
        if(file_data?.name && headerData.status === approvalStages.l2Approval){
            let fileIdList = await this.getOldTxnFileData(headerData.transactionid)
            console.log('fileIdList.length=>',fileIdList)
            fileIdList && await this.deletefileData(fileIdList,headerData.transactionid)
            fileName = await this.postfileData(headerData.transactionid, file_data);
        }

        // let action = null;
        // callFrom==="cancel"
        // ? action = approvalStages.cancelled
        // : callFrom==="reject"
        // ? action = (headerData.status === approvalStages.l1Approval ? approvalStages.l1reject : approvalStages.l2reject)
        // : action = headerData.status

        let action = null;
        callFrom==="reject"
        ? action = (headerData.status === approvalStages.l1Approval ? approvalStages.l1reject : approvalStages.l2reject)
        : callFrom==="cancel"
        ? action = approvalStages.cancelled
        : action = headerData.status

        let userEmail = headerData.initiator ? headerData.initiator : user
        //callFrom!=="cancel" && await this.sendEmail(headerData.deal_ref,headerData,userEmail,action,headerData.rejectedreason,user,fileName)
        await this.sendEmail(headerData.deal_ref,headerData,userEmail,action,headerData.rejectedreason,user,fileName)
        //async sendEmail(deal_ref, comment, reviewer, action, reason)

        console.log("returnTransactionid 3 ->",returnTransactionid)
        return returnTransactionid
    }

    async updateTransaction(headerData, user, callFrom){
        let returnVal = null;
        let updateMutation = `mutation {
            updateExcesstoolsalestransactions(input: {
                id: "${headerData.id}",
                total_price: "${headerData.total_price}",
                total_nbv: "${headerData.total_nbv}",
                total_gain_loss: "${headerData.total_gain_loss}",
                status:"${ headerData.status === approvalStages.l1Approval ? approvalStages.l2Approval : approvalStages.l3Approval}"
                last_updated_by:"${user}",
            }){
                transactionid
            }
        }`
        if(callFrom==="reject"){
            updateMutation = `mutation {
                updateExcesstoolsalestransactions(input: {
                    id: "${headerData.id}",
                    rejectedreason: "${headerData.rejectedreason}",
                    status:"${ headerData.status === approvalStages.l1Approval ? approvalStages.l1reject : approvalStages.l2reject}"
                    last_updated_by:"${user}",
                }){
                    transactionid
                }
            }`
        }
        if(callFrom==="cancel"){
            updateMutation = `mutation {
                updateExcesstoolsalestransactions(input: {
                    id: "${headerData.id}",
                    status:"${approvalStages.cancelled}"
                    last_updated_by:"${user}",
                }){
                    transactionid
                }
            }`
        }        

        console.log("createMutation==>",updateMutation)
        await API.graphql(graphqlOperation(updateMutation))
        .then(async result =>
            {
                console.log("result tool sales transaction status update ==>",result.data?.updateExcesstoolsalestransactions?.transactionid)
                //return result.data?.updateExcesstoolsalestransactions?.transactionid
                returnVal = result.data?.updateExcesstoolsalestransactions?.transactionid
            }
        ).catch(async error => {
            await this.logError(error,"Error while processing sales transaction status update")
            throw Error(`Error in sales transaction status Update`)
        })
        return returnVal;
    }
    async updateToolData(toolList){
        let returnVal = null;
        for (let toolItem of toolList) {

            let updateMutation = `mutation {
                updateExcesstoolsalestooldetails(input: {
                    id: "${toolItem.id}",
                    transactionid: "${toolItem.transactionid}",
                    no_internal_reuse: "${toolItem.no_internal_reuse}", 
                    price: "${toolItem.price}", 
                    nbv: "${toolItem.nbv}", 
                    org_eqp_price: "${toolItem.org_eqp_price}",               
                    price_percent: "${toolItem.price_percent}", 
                    fin_analysis: "${toolItem.fin_analysis?toolItem.fin_analysis.replaceAll('"','\''):""}", 
                    capitalized_date: "${toolItem.capitalized_date}"
                }) {
                    transactionid
                }
              }`
            console.log("updateMutation==>",updateMutation)
            await API.graphql(graphqlOperation(updateMutation))
            // eslint-disable-next-line no-loop-func
            .then(async result =>
                {
                    console.log("result tool sales tool details create ==>",result.data?.updateExcesstoolsalestooldetails?.transactionid)
                    returnVal = result.data?.updateExcesstoolsalestooldetails?.transactionid
                    //await this.postfileData(uniqueId, fileData);
                }
            ).catch(async error => {
                await this.logError(error,"Error while processing tool sales tool details submit.")
                throw Error(`Error`)
            });
        }
        return returnVal
    }

    //async sendEmail(deal_ref, comment, initiator, action, reason, reviewer) {
    async sendEmail(deal_ref, txnData, initiator, action, reason, reviewer, fileName, txnDataOld) {
        let resResult;
        let changedLevel;
        if(action === approvalStages.approved){
            if(txnData.total_price > txnDataOld.total_price){
                changedLevel = "re-submit-info"
            }
            else if(txnData.total_price < txnDataOld.total_price){
                changedLevel = "re-approve-price"
            }
            else if(txnData.buyer !== txnDataOld.buyer){
                changedLevel = "re-approve-buyer"
            }
        }
        // email sending to submit to list
        const reqBody = {
            deal_ref,
            txnData,
            initiator,
            action:changedLevel?changedLevel:action,
            reason,
            reviewer,
            fileName,
            txnDataOld
        }
        console.log("reqBody=>",reqBody)

        let url = null;
        url = `${process.env.REACT_APP_REST_API_END_POINT}sales/submitmail`
        // url = action === approvalStages.draft
        //     ? `${process.env.REACT_APP_REST_API_END_POINT}sales/submitmail`
        //     : action === approvalStages.l1Approval
        //     ? `${process.env.REACT_APP_REST_API_END_POINT}sales/l1submit` //l1submit
        //     : action === approvalStages.l2Approval
        //     ? `${process.env.REACT_APP_REST_API_END_POINT}sales/l2submit` //l2submit
        //     : `${process.env.REACT_APP_REST_API_END_POINT}sales/reject` //reject

        //console.log("REACT_APP_REST_API_END_POINT =>", `${process.env.REACT_APP_REST_API_END_POINT}sendEmail`)
        await axios.post(url, reqBody, {headers: {'x-api-key':process.env.REACT_APP_REST_API_KEY}})
            .then(res => {
                console.log("res from email sending=>", res)
                resResult=res.data.response;
                console.log("res response=>", resResult);
            })
            .catch(async err => await this.logError(err,"Error while sending email."))

         //Send again email if res result is not equal to 200 or 201
        if (resResult!=='Done')
        {
            await axios.post(url, reqBody, {headers: {'x-api-key':process.env.REACT_APP_REST_API_KEY}})
            .then(res => {
                console.log("res from email sending=>", res);
                console.log("res from email sending=>", res.data.response);
                
            })
            .catch(async err => await this.logError(err,"Error while sending email.")) 
        }
        else{
            console.log ("Email has been sent for status "+action);
        }   
    }

    async logError(error,msg){
        const reqBody = {
            level:"error",
            message: `${msg}. error: `+ error && JSON.stringify(error, null, 4)
        }
        axios.post( `${process.env.REACT_APP_REST_API_END_POINT}logtotable`,
                        reqBody,
                        { headers: {'x-api-key':process.env.REACT_APP_REST_API_KEY} }
                    );
    }

    async getUmesRemarks(toolid){
        console.log("ToolId=",toolid)
        let resultSet;
        
        // const q = `query MyQuery {
        //     listExcessuemsdatas(filter: {fab: {eq: "${fabid}"}, and: {module: {eq: "${module}"}}}, limit: ${process.env.REACT_APP_UEMS_DATA_TABLE_LIMIT}) {
        //       items {
        //         uems_eqp_id
        //       }
        //     }
        // }`;       
        
        const q =`query MyQuery {
            listExcessuemsdatas(filter: {uems_eqp_id: {eq: "${toolid}"}}, limit: ${process.env.REACT_APP_UEMS_DATA_TABLE_LIMIT}) {
              items {
                txn_uems_remarks
              }
            }
          }`;
        
        try {
            await API.graphql(graphqlOperation(q)).then( apiData => {
                
                apiData.data.listExcessuemsdatas.items.forEach(item=>                 
                    resultSet=item.txn_uems_remarks
                );
               
            })
        } catch (error) {
            console.log("error in fetching uems ids : ",error)
        }
        
        return resultSet;
    }
}


//module.exports = PostFormService